
    let CookieTool={
	//写入cookie
	setCookie: function(key, value, expireMinutes){
        var exdate = new Date();
        exdate.setMinutes(exdate.getMinutes() + expireMinutes);
		console.log(document.cookie)
        document.cookie = key + "=" + escape(value) + ((expireMinutes == null) ? "" : ";expires=" + exdate.toGMTString()) + ";path=/";
		console.log(document.cookie);
    },

    //读取cookie
    getCookie: function(key){
        if (document.cookie.length > 0) {
            var start = document.cookie.indexOf(key + "=");
            var end = null;
            if (start != -1) {
                start = start + key.length + 1;
                end = document.cookie.indexOf(";", start);
                if (end == -1) {
                    end = document.cookie.length;
                }
                return unescape(document.cookie.substring(start, end));
            }
        }
        return ""
    },
}

export { CookieTool }